<div style="display: contents;">
    <div class="img-container">
      <img [src]="img" />
    </div>
    <div class="text-container">
      <ng-content></ng-content>
    </div>
    <div *ngIf="mode=='gradient'" class="masthead-gradient-background"></div>
  </div>